import { Flex, Icon, Button } from "@chakra-ui/react";
import CDS from "design-system";
import { useNavigate } from "react-router";
import { ActionSummary } from "features/Resources/Shared/models";
import { dateInFormat } from "helpers/time";
import { checkpointPathById } from "helpers/url/pages/v2/actionPaths";
import { fromActionPrefixId } from "features/Resources/Shared/helpers";
import { CHECKPOINT_STATUS_CONFIG } from "./constants";
import type { CheckpointAction } from "./helpers";

interface CompactCheckpointRowProps {
  action: ActionSummary;
}

export default function CompactCheckpointRow({ action }: CompactCheckpointRowProps) {
  const navigate = useNavigate();
  const checkpoint = action.action as CheckpointAction;
  const status = checkpoint?.status || "pending";
  const config = CHECKPOINT_STATUS_CONFIG[status] || CHECKPOINT_STATUS_CONFIG.pending;
  const date = action.unifiedDate;
  const { id } = fromActionPrefixId(action.prefixId);

  return (
    <Flex align="center" gap="3" py="6px" px={2} borderBottom="1px solid" borderColor="gray.100">
      <Icon as={config.icon} boxSize="4" color={config.color} flexShrink={0} />

      <CDS.Text14 fontSize="13px" color="gray.700" noOfLines={1} flex={1} minW={0}>
        {checkpoint?.name || "Checkpoint"}
      </CDS.Text14>

      {status !== "pending" && (
        <CDS.Text10 color={config.color} fontWeight="500" flexShrink={0}>
          {config.label}
        </CDS.Text10>
      )}

      {date && (
        <CDS.Text10 color="gray.400" flexShrink={0}>
          {dateInFormat(date, "MMM D")}
        </CDS.Text10>
      )}

      <Button
        size="xs"
        variant="outline"
        fontWeight="normal"
        borderColor="gray.200"
        borderRadius="6px"
        color="content.tertiary"
        _hover={{ borderColor: "gray.300", bg: "gray.50" }}
        flexShrink={0}
        onClick={() => id && navigate(checkpointPathById(id))}
      >
        View →
      </Button>
    </Flex>
  );
}
